import eventNames from './names';

export default {
	[eventNames.ALL]: {
		[eventNames.ENGINE]: {},
		[eventNames.GEO_DATA]: {},
		[eventNames.REQUEST]: {
			[eventNames.FILTERS]: {},
			[eventNames.RESULT_CONTROLS]: {
				[eventNames.RESULTS_PER_PAGE]: {},
				[eventNames.SORT]: {},
				[eventNames.PAGE]: {},
			},
		},
		[eventNames.RESULTS]: {
			[eventNames.PRODUCTS]: {},
			[eventNames.COUNTERS]: {},
		},
		[eventNames.MAP]: {},
	},
}